module.exports = __webpack_public_path__ + "comp-6.png?1d75dd623271eac77043859c8f7f6895";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/comp-6.png
// module id = Emrj
// module chunks = 50